import { render, staticRenderFns } from "./OneChatLogDetail.vue?vue&type=template&id=59fcdda0&scoped=true&"
import script from "./OneChatLogDetail.vue?vue&type=script&lang=js&"
export * from "./OneChatLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./OneChatLogDetail.vue?vue&type=style&index=0&id=59fcdda0&scoped=true&lang=css&"
import style1 from "./OneChatLogDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fcdda0",
  null
  
)

export default component.exports